import { Button, Form, Input, Row } from 'antd'
import { Flex } from 'antd-mobile'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import { handleAmount, intl } from 'utils'
import { isAmexCardBrand, securityCodeRule } from 'utils/validateRules'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import WhiteSpace from 'components/WhiteSpace'
import AddNewCard from '../AddNewCard'
import VisaInstallments from '../VisaInstallments'
import _ from 'lodash'
import moment from 'moment'
import { NavigatorWithQS } from 'utils/navigateWithQS'
import WingBlank from 'components/WingBlank'

const setCachedPaymentMethodForResult = (orderToken, data) => {
  if (!orderToken) return
  try {
    sessionStorage.setItem(`paypage-paymentMethod-${orderToken}`, JSON.stringify(data))
  } catch (e) {
    // ignore storage issues
  }
}

class Card extends React.Component {
  constructor(props) {
    super(props)
    this.refsCard = React.createRef()
    this.state = {}
  }

  handleClick = (payMethodShortNo) => {
    this.props.form.setFieldsValue({
      payMethodShortNo,
    })
  }

  handleClickOutside = (e) => {
    if (this.refsCard.current) {
      // 组件已挂载且事件触发对象不在div内
      const result = findDOMNode(this.refsCard.current).contains(e.target)
      if (!result) {
        this.cancelOperation(e)
      }
    }
  }

  componentDidMount = () => {
    document.addEventListener(
      'mousedown',
      (e) => this.handleClickOutside(e),
      false
    )
  }

  componentWillUnmount = () => {
    document.removeEventListener(
      'mousedown',
      (e) => this.handleClickOutside(e),
      false
    )
  }

  showConfirmField = () => {
    this.setState({
      confirmFieldVisble: true,
    })
  }

  calculateTime = (payMethodShortNo) => {
    if (moment().diff(this.state.pressStart, 'seconds') >= 1) {
      clearInterval(this.Timer)
      this.setState({
        dropdownId: payMethodShortNo,
      })
    }
  }

  longPressStart = (e, payMethodShortNo) => {
    e.preventDefault()
    this.setState({
      pressStart: moment(),
    })
    this.Timer = setInterval(() => {
      this.calculateTime(payMethodShortNo)
    }, 200)
  }

  longPressEnd = () => {
    clearInterval(this.Timer)
  }

  handleContentMenu = (e, payMethodShortNo) => {
    e.preventDefault()
    this.setState({
      dropdownId: payMethodShortNo,
    })
  }

  cancelOperation = (e) => {
    this.setState({
      dropdownId: undefined,
      confirmFieldVisble: undefined,
    })
  }

  render() {
    const {
      form,
      payMethodShortNo,
      deletable,
      usable,
      displayItem,
      cardBrand,
      payMethodExtension,
    } = this.props
    const brand = cardBrand || (payMethodExtension && payMethodExtension.cardBrand)
    const isAmex = isAmexCardBrand(brand)

    return (
      <div
        ref={this.refsCard}
        key={payMethodShortNo}
        id={payMethodShortNo}
        className={`${classes.card} ${usable !== 'Y' ? classes.disabled : ''}`}
        onClick={() => {
          usable === 'Y' && this.handleClick(payMethodShortNo)
        }}
        onTouchStart={(e) => {
          deletable === 'Y' && this.longPressStart(e, payMethodShortNo)
        }}
        onTouchEnd={this.longPressEnd}
        onContextMenu={(e) => {
          deletable === 'Y' && this.handleContentMenu(e, payMethodShortNo)
        }}
      >
        <Flex>
          <img width={36} src={displayItem.preIconUrl} />
          <Flex.Item className='text-left'>
            <b>{displayItem.mainText}</b>
            <div className='text_secondary font-12'>{displayItem.subtitle}</div>
          </Flex.Item>
          {usable !== 'Y' && (
            <span className={classes.notAvailable}>
              {intl().formatMessage(messages.Notavailable)}
            </span>
          )}
          {form.getFieldValue('payMethodShortNo') === payMethodShortNo && (
            <span className='iconfont iconcomm-choose green font-24' />
          )}
        </Flex>
        {form.getFieldValue('payMethodShortNo') === payMethodShortNo && (
          <Form.Item>
            {form.getFieldDecorator(
              `cvv-${payMethodShortNo}`,
              securityCodeRule(isAmex)
            )(
              <Input
                type='password'
                onTouchStart={(e) => e.stopPropagation()}
                onContextMenu={(e) => e.stopPropagation()}
                maxLength={isAmex ? 4 : 3}
                suffix={<img height={22} src={require('./images/img2.png')} />}
                placeholder={isAmex ? 'CID' : 'CVV / CVC'}
              />
            )}
          </Form.Item>
        )}
        {this.state.dropdownId === payMethodShortNo && (
          <Flex
            className={classes.cardMenus}
            justify='center'
            align='center'
            onClick={(e) => e.stopPropagation()}
          >
            {!this.state.confirmFieldVisble ? (
              <span
                className={classes.cardMenu}
                onClick={this.showConfirmField}
              >
                <img width={20} src={require('./images/delete.png')} />
              </span>
            ) : (
              <React.Fragment>
                <Button
                  size='small'
                  type='default'
                  className='round'
                  onClick={this.cancelOperation}
                >
                  <span className='font-normal'>
                    {intl().formatMessage(messages.Cancel)}
                  </span>
                </Button>
                <Button
                  ghost
                  size='small'
                  type='danger'
                  className='round'
                  onClick={() => this.props.delete(payMethodShortNo)}
                >
                  <span className='red font-normal'>
                    {intl().formatMessage(messages.ConfirmDelete)}
                  </span>
                </Button>
              </React.Fragment>
            )}
          </Flex>
        )}
      </div>
    )
  }
}

class CardPay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      installmentPlans: null,
      showInstallments: false,
      pendingPaymentData: null,
      isAmex: false,
    }
    const { history, location } = props
    this.navigateWithQS = NavigatorWithQS.getInstance(history, location)
  }

  handleClick = (payMethodShortNo) => {
    if (this.props.siteConfig.isMobile && payMethodShortNo === 'addNewCard') {
      this.navigateWithQS.push('/pay-page/main/mobile-payment-container/add-new-card')
      return
    }
    this.props.form.setFieldsValue({
      payMethodShortNo,
    })
  }

  handleDelete = (payMethodShortNo) => {
    if (!this.props.actions || !this.props.actions.deleteCard) {
      console.error('deleteCard action is not available')
      return
    }
    this.props.actions.deleteCard({ payMethodShortNo }).then((res) => {
      if (res && res.payload && res.payload.request === 'success') {
        this.props.actions.init()
      }
    }).catch((err) => {
      console.error('Error deleting card:', err)
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    console.log('handleSubmit called')
    if (!this.props.submit) {
      console.error('submit function is not available')
      return
    }
    this.props.form.validateFields((errs, values) => {
      console.log('Form validation result:', { errs, values })
      if (!errs) {
        const { payMethodShortNo } = values
        console.log('payMethodShortNo:', payMethodShortNo)

        // If installments UI is already shown, payment is handled by VisaInstallments component
        if (this.state.showInstallments) {
          return
        }

        // Call installment plan API when pay button is clicked
        if (payMethodShortNo && payMethodShortNo !== 'addNewCard') {
          // Check if queryInstallPlan is available
          if (this.props.actions && this.props.actions.queryInstallPlan) {
            // For saved cards, send only loginToken and payMethodShortNo
            this.props.actions.queryInstallPlan({
              orderToken: this.props.siteConfig.orderToken,
              payMethodShortNo
            })
              .then((res) => {
                const { installmentPlanList, supplierCode } = res.payload || {}
                // If supplierCode is VISA and we have installment plans, show installments UI
                if (supplierCode === 'VISA' && installmentPlanList && installmentPlanList.length > 0) {
                  // Cache card details so result page can display "VISA Debit/Credit Card(XXXX)" even if API omits paymentMethod
                  const selectedCard = (this.props.cardList || []).find((c) => c.payMethodShortNo === payMethodShortNo)
                  const cardNoSuffix =
                    _.get(selectedCard, 'cardNoSuffix') ||
                    _.get(selectedCard, 'payMethodExtension.cardNoSuffix') ||
                    _.get(selectedCard, 'payMethodExtension.cardNoLast4') ||
                    _.get(selectedCard, 'payMethod.payMethodExtension.cardNoSuffix')
                  const debitCredit =
                    _.get(selectedCard, 'debitCredit') ||
                    _.get(selectedCard, 'payMethodExtension.debitCredit') ||
                    _.get(selectedCard, 'payMethod.payMethodExtension.debitCredit')
                  const cardBrand =
                    (_.get(selectedCard, 'cardBrand') ||
                      _.get(selectedCard, 'payMethodExtension.cardBrand') ||
                      _.get(selectedCard, 'payMethod.payMethodExtension.cardBrand') ||
                      supplierCode)?.toLowerCase()
                  const descriptionFromUI =
                    _.get(selectedCard, 'displayItem.mainText') ||
                    _.get(selectedCard, 'displayItem.subtitle')
                  setCachedPaymentMethodForResult(this.props.siteConfig.orderToken, {
                    cardBrand,
                    cardNoSuffix,
                    debitCredit,
                    supplierCode,
                    description: descriptionFromUI,
                  })
                  this.setState({
                    installmentPlans: installmentPlanList,
                    showInstallments: true,
                    pendingPaymentData: {
                      cvv: values[`cvv-${payMethodShortNo}`],
                      payMethodShortNo: payMethodShortNo,
                      method: 'PAY_BY_CARD_ID',
                      siteConfig: this.props.siteConfig,
                      tabName: this.props.tabName,
                    },
                  })
                } else {
                  // No installments available, proceed with normal payment flow
                  console.log('CardPay - No installments, proceeding with normal payment')
                  this.props.submit({
                    cvv: values[`cvv-${payMethodShortNo}`],
                    payMethodShortNo: payMethodShortNo,
                    method: 'PAY_BY_CARD_ID',
                    siteConfig: this.props.siteConfig,
                    tabName: this.props.tabName,
                  })
                }
              })
              .catch((err) => {
                console.log('Installment Plan API Error:', err)
                // On error, proceed with normal payment flow
                this.props.submit({
                  cvv: values[`cvv-${payMethodShortNo}`],
                  payMethodShortNo: payMethodShortNo,
                  method: 'PAY_BY_CARD_ID',
                  siteConfig: this.props.siteConfig,
                  tabName: this.props.tabName,
                })
              })
          } else {
            // queryInstallPlan not available, proceed directly with payment
            this.props.submit({
              cvv: values[`cvv-${payMethodShortNo}`],
              payMethodShortNo: payMethodShortNo,
              method: 'PAY_BY_CARD_ID',
              siteConfig: this.props.siteConfig,
              tabName: this.props.tabName,
            })
          }
        } else {
          console.log('Skipping API call - payMethodShortNo is:', payMethodShortNo)
          // For new cards, proceed directly with payment
          this.props.submit({
            cvv: values[`cvv-${payMethodShortNo}`],
            payMethodShortNo: payMethodShortNo,
            method: 'PAY_BY_CARD_ID',
            siteConfig: this.props.siteConfig,
            tabName: this.props.tabName,
          })
        }
      } else {
        console.log('Form validation errors:', errs)
      }
    })
  }

  handleInstallmentPay = (data) => {
    const { pendingPaymentData } = this.state
    if (pendingPaymentData) {
      this.props.submit({
        ...pendingPaymentData,
        siteConfig: this.props.siteConfig,
        tabName: this.props.tabName,
        installmentPlanId: data.installmentPlanId,
        installmentPlan: data.installmentPlan,
      })
    }
  }

  render() {
    const {
      siteConfig,
      form,
      loading,
      submit,
      optAddCardItems,
      cardList,
      canAddCard,
      saveCard
    } = this.props
    const { showInstallments, installmentPlans } = this.state
    const payMethodShortNo = form.getFieldValue('payMethodShortNo')

    // Show installments UI if available
    if (showInstallments && installmentPlans) {
      return (
        <div className={classes.componentsPaymentMethodsCardPay}>
          <VisaInstallments
            installmentPlans={installmentPlans}
            loading={loading}
            onPay={this.handleInstallmentPay}
            siteConfig={siteConfig}
          />
        </div>
      )
    }

    const formContent = (
      <Form onSubmit={this.handleSubmit}>
        {form.getFieldDecorator('payMethodShortNo')(<Input className='hidden' />)}

        {payMethodShortNo !== 'addNewCard' &&
            cardList.map((card) => {
              return (
                <Card
                  key={card.payMethodShortNo}
                  {...card}
                  form={form}
                  delete={this.handleDelete}
                />
              )
            })}

        {!cardList.length && siteConfig.loginType === 'memberPhone' && (
          <React.Fragment>
            <WhiteSpace />
            <Row
              type='flex'
              align='middle'
              justify='center'
              className={classes.noCardReminder}
            >
              <span className='iconfont iconcomm-warning-circle-fill font-20' />
              {intl().formatMessage(messages.Wehavenotfoundanycardsofyours)}
            </Row>
            <WhiteSpace size='lg' />
          </React.Fragment>
        )}

        {/* 添加新卡模块 */}
        {canAddCard &&
          (payMethodShortNo !== 'addNewCard' ? (
            <React.Fragment>
              <div className={classes.card} onClick={() => this.handleClick('addNewCard')}>
                <Flex>
                  <img width={36} src={require('./images/img1.png')} />
                  <Flex.Item className='text-left'>
                    <b>{intl().formatMessage(messages.Useanewcard)}</b>
                    <div className='text_secondary font-12'>{intl().formatMessage(messages.Maximum3toadd)}</div>
                  </Flex.Item>
                  <span className={classes.addIcon}>
                    <b className='iconfont iconplus text_main font-14' />
                  </span>
                </Flex>
              </div>
              {payMethodShortNo && !siteConfig.isMobile && (
                <Button loading={loading} block size='large' type='primary' htmlType='submit'>
                  {intl().formatMessage(messages.Pay)}{' '}
                  {_.get(siteConfig, 'payInfo.payAmount') && handleAmount(siteConfig.payInfo.payAmount)}
                </Button>
              )}
            </React.Fragment>
          ) : (
            <div className='text-left clearfix' style={{ lineHeight: '20px' }}>
              <b>{intl().formatMessage(messages.Useanewcard)}</b>
              {!!cardList.length && (
                <b className='iconfont iconState-Failed red font-20 pull-right' onClick={() => this.handleClick()} />
              )}
              <WhiteSpace />
            </div>
          ))}
      </Form>
    )
    if (siteConfig.isMobile) {
      return (
        <>
          <Flex.Item className={classes.componentsPaymentMethodsCardPay}>
            <WhiteSpace />
            {formContent}
          </Flex.Item>
          <div>
            <WingBlank>
              <WhiteSpace />
              {payMethodShortNo && (
                <Button loading={loading} block size='large' type='primary' onClick={this.handleSubmit}>
                  {intl().formatMessage(messages.Pay)}{' '}
                  {_.get(siteConfig, 'payInfo.payAmount') && handleAmount(siteConfig.payInfo.payAmount)}
                </Button>
              )}
              <WhiteSpace />
            </WingBlank>
          </div>
        </>
      )
    }

    return (
      <div className={classes.componentsPaymentMethodsCardPay}>
        {formContent}
        {payMethodShortNo === 'addNewCard' && (
          <AddNewCard
            submit={submit}
            loading={loading}
            saveCard={saveCard}
            payMethods={this.props.payMethods}
            optAddCardItems={[...optAddCardItems, 'saveCard']}
          />
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  // Dynamic import to avoid circular dependencies
  const { queryInstallPlan } = require('routes/PayPage/Main/modules')
  return {
    queryInstallPlan: (data) => {
      return dispatch(queryInstallPlan(data))
    },
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...ownProps,
    submit: ownProps.submit, // Explicitly preserve submit prop
    actions: {
      ...(ownProps.actions || {}),
      queryInstallPlan: dispatchProps.queryInstallPlan,
    },
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  mapDispatchToProps,
  mergeProps
)(Form.create()(CardPay))
